module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUBAMAAABlm+CwAAAAJFBMVEUAAAA1NTU0NDQ1NTUzMzMyMjIyMjIzMzMzMzMzMzMzMzMzMzPhNURdAAAAC3RSTlMASElNUFFX4uXm+0P8RvMAAABuSURBVBjTTc+xDYNAEETRH10LlEANrsASHZARX2bLGaFDYjpAJFsA6KY5B3vW7mRPPxqA8Q2PHd96wdYWhwTSmdGTo6cOTw7TEai6AsUSeL4YPn8Aa1sSdAYmtUAxBagZxRKoGcVuPwjA/PXr/ADISktyAUQHJgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/common/change-label@2x.png
// module id = 5f5W
// module chunks = 2